import {
  SET_SHOW_HAS_BILLING_ADDRESS_BADGE,
  SET_SHOW_HAS_BILLING_INFO_BADGE,
} from './types';

export const setShowHasBillingAddressBadge = (payload) => ({ type: SET_SHOW_HAS_BILLING_ADDRESS_BADGE, payload });

export const setShowHasBillingInfoBadge = (payload) => ({ type: SET_SHOW_HAS_BILLING_INFO_BADGE, payload });
